/*
 *
 *  actions
 *
 */

import {
  LOAD_RECORD,
  LOAD_RECORD_SUCCESS,
  LOAD_RECORD_ERROR,
  LOAD_RECORDS,
  LOAD_RECORDS_SUCCESS,
  LOAD_RECORDS_ERROR,
  LOAD_RECORD_CLIENT_DETAILS,
  LOAD_RECORD_CLIENT_PROFILE_BY_ID,
  LOAD_RECORD_CLIENT_PROFILE_BY_ID_SUCCESS,
  LOAD_RECORD_CLIENT_PROFILE_BY_ID_ERROR,
  LOAD_RECORD_CLIENT_DETAILS_SUCCESS,
  LOAD_RECORD_CLIENT_DETAILS_ERROR,
  LOAD_RECORD_CLIENT_DETAILS_META_DATA_SUCCESS,
  LOAD_RECORD_CLIENT_DETAILS_META_DATA_ERROR,
  LOAD_RECORD_CLIENT_DETAILS_META_DATA,
  CREATE_RECORD,
  CREATE_RECORD_SUCCESS,
  CREATE_RECORD_ERROR,
  UPDATE_CLIENT_PROFILE_RECORD,
  UPDATE_RECORD,
  UPDATE_RECORD_SUCCESS,
  UPDATE_RECORD_ERROR,
  DELETE_RECORD,
  DELETE_RECORD_SUCCESS,
  DELETE_RECORD_ERROR,
  LOAD_RECORDS_VALID_CACHE,
  LOAD_RECORDS_META_DATA,
  LOAD_RECORDS_META_DATA_SUCCESS,
  LOAD_RECORDS_META_DATA_ERROR,
  UPDATE_STATUS,
  UPDATE_STATUS_SUCCESS,
  UPDATE_STATUS_ERROR,
  LEAD_STATUS,
  LEAD_STATUS_SUCCESS,
  LEAD_STATUS_ERROR,
  LOAD_CLIENT_RECORD,
  UPDATE_CLIENT_STATUS_SUCCESS,
  UPDATE_CLIENT_STATUS_ERROR,
  UPDATE_CLIENT_STATUS,
  DELETE_CLIENT_RECORD,
  DELETE_CLIENT_RECORD_SUCCESS,
  DELETE_CLIENT_RECORD_ERROR,
  UPDATE_CLIENT_RECORD,
  UPDATE_CLIENT_RECORD_SUCCESS,
  UPDATE_CLIENT_RECORD_ERROR,
  UPDATE_CLIENT_PROFILE_RECORD_SUCCESS,
  UPDATE_CLIENT_PROFILE_RECORD_ERROR,
  LOAD_CLIENT_QUESTIONS_LIST,
  LOAD_CLIENT_QUESTIONS_LIST_SUCCESS,
  LOAD_CLIENT_QUESTIONS_LIST_ERROR,
  ADD_CLIENT_QUESTIONS_LIST,
  ADD_CLIENT_QUESTIONS_LIST_SUCCESS,
  ADD_CLIENT_QUESTIONS_LIST_ERROR,
  LOAD_CLIENT_DETAILS_QUESTIONS_LIST,
  LOAD_CLIENT_DETAILS_QUESTIONS_LIST_SUCCESS,
  LOAD_CLIENT_DETAILS_QUESTIONS_LIST_ERROR,
  NEW_LEAD_CREATION,
  NEW_LEAD_CREATION_ERROR,
  NEW_LEAD_CREATION_SUCCESS,

  ADD_CLIENT_COMPLETE,
  ADD_CLIENT_COMPLETE_SUCCESS,
  ADD_CLIENT_COMPLETE_ERROR,

  ADD_CLIENT_APPEARANCE,
  ADD_CLIENT_APPEARANCE_SUCCESS,
  ADD_CLIENT_APPEARANCE_ERROR,
  
  UPDATE_CLIENT_TYPE,
  UPDATE_CLIENT_TYPE_SUCCESS,
  UPDATE_CLIENT_TYPE_ERROR,

  UPDATE_ENGAGEMENT,
  UPDATE_ENGAGEMENT_SUCCESS,
  UPDATE_ENGAGEMENT_ERROR,

  UPDATE_HIGH_GOOD,
  UPDATE_HIGH_GOOD_SUCCESS,
  UPDATE_HIGH_GOOD_ERROR
} from "./constants"

export function loadRecordsCacheHit() {
  return {
    type: LOAD_RECORDS_VALID_CACHE,
  }
}

/**
 *
 * @param {object} filter
 * @param {boolean} invalidateCache
 * @returns
 */
export function loadRecords(id) {
  return {
    type: LOAD_RECORDS,
    id,
  }
}

/**
 * @param {array} records
 */
export function loadRecordsSuccess(records) {
  return {
    type: LOAD_RECORDS_SUCCESS,
    records,
  }
}

/**
 * @param {string} error
 */
export function loadRecordsError(error) {
  return {
    type: LOAD_RECORDS_ERROR,
    error,
  }
}

/**
 * @param {integer} id
 */
export function loadRecord(id) {
  return {
    type: LOAD_RECORD,
    id,
  }
}

/**
 * @param {object} record
 * @param {object} recordsMetaData
 */
export function loadRecordSuccess(record, recordsMetaData) {
  return {
    type: LOAD_RECORD_SUCCESS,
    record,
    recordsMetaData,
  }
}

/**
 * @param {string} error
 */
export function loadRecordError(error) {
  return {
    type: LOAD_RECORD_ERROR,
    error,
  }
}

/**
 * @param {integer} id
 */
export function loadClientRecord() {
  return {
    type: LOAD_CLIENT_RECORD,
  }
}

/**
 * @param {object} record
 * @param {object} recordsMetaData
 */
export function loadClientRecordSuccess(record_profile) {
  return {
    type: LOAD_RECORD_CLIENT_DETAILS_SUCCESS,
    record_profile,
  }
}
/**
 * @param {integer} id
 */
export function loadRecordClientDetails(id) {
  return {
    type: LOAD_RECORD_CLIENT_DETAILS,
    id,
  }
}

/**
 * @param {object} record
 * @param {object} recordsMetaData
 */
export function loadRecordClientDetailsSuccess(record_client_details) {
  return {
    type: LOAD_RECORD_CLIENT_DETAILS_SUCCESS,
    record_client_details,
  }
}

/**
 * @param {string} error
 */
export function loadRecordClientDetailsError(error) {
  return {
    type: LOAD_RECORD_CLIENT_DETAILS_ERROR,
    error,
  }
}
export function loadRecordsClientDetailsMetaData() {
  return {
    type: LOAD_RECORD_CLIENT_DETAILS_META_DATA,
  }
}

/**
 *
 * @param {object} recordsMetaData
 * @returns
 */
export function loadRecordsClientDetailsMetaDataSuccess(recordsMetaData) {
  return {
    type: LOAD_RECORD_CLIENT_DETAILS_META_DATA_SUCCESS,
    recordsMetaData,
  }
}

/**
 *
 * @param {string} error
 * @returns
 */
export function loadRecordsClientDetailsMetaDataError(error) {
  return {
    type: LOAD_RECORD_CLIENT_DETAILS_META_DATA_ERROR,
    error,
  }
}
/**
 *
 * @param {object} record
 * @param {function} setSubmitting
 * @param {function} redirect
 * @returns
 */
export function createRecord(profileData, record, setSubmitting, redirect) {
  console.log(profileData, "---------------create record-----------")

  return {
    type: CREATE_RECORD,
    profileData,
    record,
    setSubmitting,
    redirect,
  }
}

/**
 *
 * @param {object} record
 * @param {function} setSubmitting
 * @param {function} redirect
 * @returns
 */
export function updateClientProfileRecord(record, setSubmitting, redirect) {
  console.log(record, "---------------create client profile  record-----------")

  return {
    type: UPDATE_CLIENT_PROFILE_RECORD,
    record,
    setSubmitting,
    redirect,
  }
}

export function updateClientProfileRecordSuccess(record, success) {
  return {
    type: UPDATE_CLIENT_PROFILE_RECORD_SUCCESS,
    record: record,
    success,
  }
}

/**
 * @param {string} error
 */
export function updateClientProfileRecordError(error) {
  return {
    type: UPDATE_CLIENT_PROFILE_RECORD_ERROR,
    error,
  }
}
/**
 *
 * @param {object} record
 * @param {string} success
 * @returns
 */
export function createRecordSuccess(profileData, record, success) {
  console.log(profileData, "--------------")
  return {
    type: CREATE_RECORD_SUCCESS,
    profileData: profileData,
    record: record,
    success: success,
  }
}

/**
 * @param {string} error
 */
export function createRecordError(error) {
  return {
    type: CREATE_RECORD_ERROR,
    error,
  }
}

/**
 *
 * @param {object} record
 * @param {function} setSubmitting
 * @param {function} redirect
 * @returns
 */
export function updateRecord(record, setSubmitting, redirect) {
  return {
    type: UPDATE_RECORD,
    record,
    setSubmitting,
    redirect,
  }
}

/**
 *
 * @param {object} record
 * @param {string} success
 * @returns
 */
export function updateRecordSuccess(record, success) {
  return {
    type: UPDATE_RECORD_SUCCESS,
    record,
    success,
  }
}

/**
 * @param {string} error
 */
export function updateRecordError(error) {
  return {
    type: UPDATE_RECORD_ERROR,
    error,
  }
}

export function updateClientRecord(profileData) {
  console.log("&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&")
  console.log(profileData)
  console.log("&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&")

  return {
    type: UPDATE_CLIENT_RECORD,
    profileData,
  }
}

/**
 *
 * @param {object} record
 * @param {string} success
 * @returns
 */
export function updateClientRecordSuccess(profileData, record, success) {
  return {
    type: UPDATE_CLIENT_RECORD_SUCCESS,
    profileData,
    record,
    success,
  }
}

/**
 * @param {string} error
 */
export function updateClientRecordError(error) {
  return {
    type: UPDATE_CLIENT_RECORD_ERROR,
    error,
  }
}

/**
 *
 * @param {string} id
 * @param {function} setSubmitting
 * @param {function} redirect
 * @returns
 */
export function deleteRecord(id, setSubmitting, redirect) {
  return {
    type: DELETE_RECORD,
    id,
    setSubmitting,
    redirect,
  }
}

/**
 *
 * @param {integer} id
 * @param {string} success
 * @returns
 */
export function deleteRecordSuccess(id, success) {
  return {
    type: DELETE_RECORD_SUCCESS,
    id,
    success,
  }
}

/**
 * @param {string} error
 */
export function deleteRecordError(error) {
  return {
    type: DELETE_RECORD_ERROR,
    error,
  }
}
/**
 *
 * @param {integer} id
 * @returns
 */
export function deleteClientRecord(clientRemoveId) {
  console.log(clientRemoveId, "action for delete")
  return {
    type: DELETE_CLIENT_RECORD,
    clientRemoveId,
  }
}

/**
 *
 * @param {integer} id
 * @param {string} success
 * @returns
 */
export function deleteClientRecordSuccess(clientRemoveId, success) {
  return {
    type: DELETE_CLIENT_RECORD_SUCCESS,
    clientRemoveId,
    success,
  }
}

/**
 * @param {string} error
 */
export function deleteClientRecordError(error) {
  return {
    type: DELETE_CLIENT_RECORD_ERROR,
    error,
  }
}

export function loadRecordsMetaData() {
  return {
    type: LOAD_RECORDS_META_DATA,
  }
}

/**
 *
 * @param {object} recordsMetaData
 * @returns
 */
export function loadRecordsMetaDataSuccess(recordsMetaData) {
  return {
    type: LOAD_RECORDS_META_DATA_SUCCESS,
    recordsMetaData,
  }
}

/**
 *
 * @param {string} error
 * @returns
 */
export function loadRecordsMetaDataError(error) {
  return {
    type: LOAD_RECORDS_META_DATA_ERROR,
    error,
  }
}

/**
 *
 * @param {object} record
 * @param {function} setSubmitting
 * @param {function} redirect
 * @returns
 */
export function updateStatus(record, setSubmitting, redirect) {
  return {
    type: UPDATE_STATUS,
    record,
    setSubmitting,
    redirect,
  }
}

/**
 *
 * @param {object} record
 * @param {string} success
 * @returns
 */
export function updateStatusSuccess(record, success) {
  return {
    type: UPDATE_STATUS_SUCCESS,
    record,
    success,
  }
}

/**
 *
 * @param {string} error
 * @returns
 */
export function updateStatusError(error) {
  return {
    type: UPDATE_STATUS_ERROR,
    error,
  }
}
export function updateClientStatus(record, setSubmitting, redirect) {
  return {
    type: UPDATE_CLIENT_STATUS,
    record,
    setSubmitting,
    redirect,
  }
}

/**
 *
 * @param {object} record
 * @param {string} success
 * @returns
 */
export function updateClientStatusSuccess(record, success) {
  return {
    type: UPDATE_CLIENT_STATUS_SUCCESS,
    record,
    success,
  }
}

/**
 *
 * @param {string} error
 * @returns
 */
export function updateClientStatusError(error) {
  return {
    type: UPDATE_CLIENT_STATUS_ERROR,
    error,
  }
}

/**
 *
 * @param {object} record
 * @param {function} setSubmitting
 * @param {function} redirect
 * @returns
 */
export function leadStatus(record, setSubmitting, redirect) {
  return {
    type: LEAD_STATUS,
    record,
    setSubmitting,
    redirect,
  }
}

/**
 *
 * @param {object} record
 * @param {string} success
 * @returns
 */
export function leadStatusSuccess(record, success) {
  return {
    type: LEAD_STATUS_SUCCESS,
    record,
    success,
  }
}

/**
 *
 * @param {string} error
 * @returns
 */
export function leadStatusError(error) {
  return {
    type: LEAD_STATUS_ERROR,
    error,
  }
}

/**
 * @param {integer} id
 */
export function loadRecordClientProfileById(client) {
  return {
    type: LOAD_RECORD_CLIENT_PROFILE_BY_ID,
    client,
  }
}

export function loadRecordClientProfileByIdSuccess(record_client_profile) {
  console.log("success --> ", record_client_profile)
  return {
    type: LOAD_RECORD_CLIENT_PROFILE_BY_ID_SUCCESS,
    record_client_profile,
  }
}

export function loadRecordClientProfileByIdError(error) {
  return {
    type: LOAD_RECORD_CLIENT_PROFILE_BY_ID_ERROR,
    error,
  }
}

//Client questions list

/**
 * @param {integer} id
 */
export function loadClientQuestionList() {
  return {
    type: LOAD_CLIENT_QUESTIONS_LIST,
  }
}

export function loadClientQuestionListSuccess(questions_list) {
  return {
    type: LOAD_CLIENT_QUESTIONS_LIST_SUCCESS,
    questions_list,
  }
}

export function loadClientQuestionListError(error) {
  return {
    type: LOAD_CLIENT_QUESTIONS_LIST_ERROR,
    error,
  }
}

/**
 * @param {integer} id
 */
export function loadClientDetailsQuestionsList(id) {
  return {
    type: LOAD_CLIENT_DETAILS_QUESTIONS_LIST,
    id,
  }
}

export function loadClientDetailsQuestionsListSuccess(client_questions_list) {
  return {
    type: LOAD_CLIENT_DETAILS_QUESTIONS_LIST_SUCCESS,
    client_questions_list,
  }
}

export function loadClientDetailsQuestionsListError(error) {
  return {
    type: LOAD_CLIENT_DETAILS_QUESTIONS_LIST_ERROR,
    error,
  }
}

/**
 * @param {integer} id
 */
export function createClientQuestionList(questionsList) {
  return {
    type: ADD_CLIENT_QUESTIONS_LIST,
    questionsList,
  }
}

export function createClientQuestionListSuccess(questionsList, success) {
  return {
    type: ADD_CLIENT_QUESTIONS_LIST_SUCCESS,
    questionsList,
    success,
  }
}

export function createClientQuestionListError(error) {
  return {
    type: ADD_CLIENT_QUESTIONS_LIST_ERROR,
    error,
  }
}

//New lead creation
export function createNewLead(newLead) {
  return {
    type: NEW_LEAD_CREATION,
    newLead,
  }
}

export function createNewLeadSuccess(newLead, success) {
  return {
    type: NEW_LEAD_CREATION_SUCCESS,
    newLead,
    success,
  }
}

export function createNewLeadError(error) {
  return {
    type: NEW_LEAD_CREATION_ERROR,
    error,
  }
}
export function addClientComplete(client_complete) {
  return {
    type: ADD_CLIENT_COMPLETE,
    client_complete,
  }
}

export function addClientCompleteSuccess(success) {
  return {
    type: ADD_CLIENT_COMPLETE_SUCCESS,
    success,
  }
}

export function addClientCompleteError(error) {
  return {
    type:ADD_CLIENT_COMPLETE_ERROR,
    error,
  }
}

// addClientAppearance ratings
export function addClientAppearance(clientAppearance_details) {
  return {
    type: ADD_CLIENT_APPEARANCE,
    clientAppearance_details,
  }
}

export function addClientAppearanceSuccess(success) {
  return {
    type: ADD_CLIENT_APPEARANCE_SUCCESS,
    success,
  }
}

export function addClientAppearanceError(error) {
  return {
    type:ADD_CLIENT_APPEARANCE_ERROR,
    error,
  }
}
//updateClientType

export function updateClientType(clientType) {
  return {
    type: UPDATE_CLIENT_TYPE,
    clientType,
  }
}
export function updateClientTypeSuccess(dataDetails) {
  return {
    type: UPDATE_CLIENT_TYPE_SUCCESS,
    dataDetails,
  }
}
export function updateClientTypeError(error) {
  return {
    TYPE: UPDATE_CLIENT_TYPE_ERROR,
    error,
  }
}

//updateEngagement

export function updateEngagement(engage_details) {
  return {
    type: UPDATE_ENGAGEMENT,
    engage_details,
  }
}
export function updateEngagementSuccess(dataDetails) {
  return {
    type: UPDATE_ENGAGEMENT_SUCCESS,
    dataDetails,
  }
}
export function updateEngagementError(error) {
  return {
    TYPE: UPDATE_ENGAGEMENT_ERROR,
    error,
  }
}

//updateHighGood

export function updateHighGood(highGood_details) {
  return {
    type: UPDATE_HIGH_GOOD,
    highGood_details,
  }
}
export function updateHighGoodSuccess(dataDetails) {
  return {
    type: UPDATE_HIGH_GOOD_SUCCESS,
    dataDetails,
  }
}
export function updateHighGoodError(error) {
  return {
    TYPE: UPDATE_HIGH_GOOD_ERROR,
    error,
  }
}
const actions = {
  loadRecord,
  loadRecordSuccess,
  loadRecordError,
  loadRecords, 
  loadRecordsSuccess,
  loadRecordsError,
  loadRecordClientDetails,
  loadRecordClientProfileById,
  loadRecordClientProfileByIdSuccess,
  loadRecordClientProfileByIdError,
  loadRecordClientDetailsSuccess,
  loadRecordClientDetailsError,
  loadRecordsClientDetailsMetaDataSuccess,
  loadRecordsClientDetailsMetaData,
  loadRecordsClientDetailsMetaDataError,
  createRecord,
  updateClientProfileRecord,
  createRecordSuccess,
  createRecordError,
  updateRecord,
  updateRecordSuccess,
  updateRecordError,
  deleteRecord,
  deleteRecordSuccess,
  deleteRecordError,
  updateClientRecord,
  updateClientRecordSuccess,
  updateClientRecordError,
  deleteClientRecord,
  deleteClientRecordSuccess,
  deleteClientRecordError,
  loadRecordsCacheHit,
  loadRecordsMetaData,
  loadRecordsMetaDataSuccess,
  loadRecordsMetaDataError,
  updateStatus,
  updateStatusSuccess,
  updateStatusError,
  updateClientStatus,
  updateClientStatusSuccess,
  updateClientStatusError,
  loadClientRecordSuccess,
  leadStatus,
  loadClientRecord,
  leadStatusSuccess,
  leadStatusError,

  //Client Questions list
  loadClientQuestionList,
  loadClientQuestionListSuccess,
  loadClientQuestionListError,

  loadClientDetailsQuestionsList,
  loadClientDetailsQuestionsListSuccess,
  loadClientDetailsQuestionsListError,

  createClientQuestionList,
  createClientQuestionListSuccess,
  createClientQuestionListError,

  //New lead
  createNewLead,
  createNewLeadSuccess,
  createNewLeadError,

  addClientComplete,
  addClientCompleteSuccess,
  addClientCompleteError,

  addClientAppearance,
  addClientAppearanceSuccess,
  addClientAppearanceError,

  updateClientType,
  updateClientTypeSuccess,
  updateClientTypeError,

  updateEngagement,
  updateEngagementSuccess,
  updateEngagementError,

  updateHighGood,
  updateHighGoodSuccess,
  updateHighGoodError
}

export default actions
